import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { environment } from '../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ModalAlteracaoAssociacaoService {

  constructor(
    private httpService: HttpService
  ) { }

  partnerSearch(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doPost('/partnerEdit', data, successHandle, errorHandle);

  }

  partner(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/partnerSearch', data, successHandle, errorHandle);

  }

  enterpriseListByCnpj(data: any, successHandle: Function, errorHandle: Function) {
    
    this.httpService.doGet('/informationPartner', data, successHandle, errorHandle);

  }
  
}
